import { createEventTracker } from '../util';
import { EventArchiveAnalytics, EventSaveAnalytics } from './types';

export const trackEventSaved = createEventTracker<EventSaveAnalytics>('Event Saved');
export const trackEventArchived = createEventTracker<EventArchiveAnalytics>('Event Archived');
